import styled from 'styled-components';
import { text, titleSmall } from 'styles-js/mixins/typography';

export const PanelWrapperPost = styled.div`
  @media (${({ theme }) => theme.underScreenMedium}) {
    padding: 0 0 12px;
  }
`;

export const Section = styled.div`
  ${text};
  margin: 0 0 30px;
`;

export const SubTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  button {
    margin: 0;
  }
`;

export const SubTitle = styled.div`
  ${titleSmall};
  font-weight: 600;
`;

// Default blue gradient banner
export const BannerWrapper = styled.div`
  overflow: hidden;
  display: block;
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg,transparent 55%,hsla(0,0%,39%,.25)), #9ecff9;

  @media (${({ theme }) => theme.overScreenMedium}) {
    height: 200px;
  }
`;

export const BannerContainer = styled.div<{ imageUrl: string }>`
  position: relative;
  width: 100%;
  background-image: url(${({ imageUrl }) => imageUrl});
  background-size: cover;
  background-position: 50%;
  padding-top: 20%;
  max-width: 1900px;
  margin: 0 auto;

  @media (min-width: 1900px) {
    padding-top: 0;
    height: 380px;
  }
`;

export const AvatarWrapper = styled.div`
  position: absolute;
  bottom: 15px;
  left: 10px;
  border-radius: 50%;
  box-shadow: ${({ theme }) => theme.shadowLight};
  border: ${({ theme }) => theme.greyLine};
  background-color: ${({ theme }) => theme.colorWhite};;
  @media (${({ theme }) => theme.underScreenSmall}) {
    top: -38px;
    bottom: auto;
    left: 50%;
    transform: translate(-50%);
  }
`;

export const AvatarContainer = styled.div<{ imageUrl: string }>`
  width: 56px;
  height: 56px;
  display: block;
  border-radius: 50%;
  background-image: url(${({ imageUrl }) => imageUrl});
  background-clip: padding-box;
  background-size: cover;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colorGreyLight};
  border: 2px solid ${({ theme }) => theme.colorWhite};
  @media (${({ theme }) => theme.overScreenSmall}) {
    width: 130px;
    height: 130px;
    border-width: 5px;
  }
`;

export const AttentionContainer = styled.div<{ as?: React.ElementType; margin?: string }>`
  margin: ${props => props.margin ? props.margin : '0'};
  background-color: ${({ theme }) => theme.colorBlueBackground};
  padding: 10px;
  border-radius: 3px;
  width: 100%;
`;

export const PostsContainer = styled.div`
  padding: 0 40px;
  border: ${({ theme }) => theme.greyLine};
  width: 0;         // this
  min-width: 100%;  // and this forces the container to take the established width of the parent (prod-1093)
  @media (${({ theme }) => theme.underScreenSmall}) {
    padding: 0;
    border: none;
  }
`;
